import { render, staticRenderFns } from "./EFile.vue?vue&type=template&id=4892eda9&scoped=true&"
import script from "./EFile.vue?vue&type=script&lang=js&"
export * from "./EFile.vue?vue&type=script&lang=js&"
import style0 from "./EFile.vue?vue&type=style&index=0&id=4892eda9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892eda9",
  null
  
)

export default component.exports